import baseSpacingScale from './base-spacing-scale';

const space = {
  ...baseSpacingScale,
  auto: 'auto',
};

export { space as default };
